<div class="camera">
  <webcam [trigger]="triggerObservable"
          [imageQuality]="1"
          (imageCapture)="imageCapture.emit($event)"></webcam>
</div>
